<ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '250px', height: '16px', margin: '0 0 8px 0' }"></ui-skeleton>
<ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '200px', height: '24px', margin: '0 0 8px 0' }"></ui-skeleton>
<ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '300px', height: '16px', margin: '0' }"></ui-skeleton>

<ui-list class="sp-mt-32" [uiSplit]="false">
  <ui-list-item class="sp-mb-32" *ngFor="let formItem of formItems">
    <ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="{ width: '100px', height: '16px', margin: '0' }"></ui-skeleton>
    <ui-skeleton [uiActive]="true" [uiCustom]="true" [uiCustomMeasurements]="formItem"></ui-skeleton>
  </ui-list-item>
</ui-list>
